module.exports = "../../static/images/course-show1.8ba245.png";